
function buildUser(data) {
    if (!data) return null;
    return {
        ...data,
        nombreCompleto: `${data.nombres || ''} ${data.paterno || ''} ${data.materno || ''}`.trim(),
    };
}

const authStore = {
    state() {
        const session = JSON.parse(sessionStorage.getItem('session') || 'null');
        return {
            user: buildUser(session),
        };
    },
    mutations: {
        setUser(state, payload) {
            state.user = buildUser(payload.user);
        },
    },
    getters: {
        user(state) {
            return state.user;
        },
    },
    actions: {
        setUser(context, payload) {
            context.commit('setUser', payload);
        },
    },
};

export default authStore;